import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SearchResultsGridLayoutComponent } from "./search-results-grid-layout/search-results-grid-layout.component";
import { RouterModule, Routes } from "@angular/router";
import { SearchResultsSharedModule } from "../search-results-shared/search-results-shared.module";
import { NoSearchResultsComponent } from "./no-search-results/no-search-results.component";
import { MatPaginatorModule } from "@angular/material/paginator";

import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { LayoutModule } from "@rubbl-layout";
import { RubblFormsModule } from "@rubbl-forms";
import { CartModule } from "@rubbl-cart";
import { MarketingModule } from "@rubbl-marketing";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { SearchResultsModule } from "@rubbl-search-results";

const routes: Routes = [
  { path: "", redirectTo: "all", pathMatch: "full" },
  { path: "all", component: SearchResultsGridLayoutComponent, data: { hideFooter: true, doNotUpdateSeo: true } },
  { path: ":primaryType", component: SearchResultsGridLayoutComponent, data: { hideFooter: true, doNotUpdateSeo: true } },
  { path: ":primaryType/:cityState", component: SearchResultsGridLayoutComponent, data: { hideFooter: true, doNotUpdateSeo: true } },
  { path: ":primaryType/:cityState/:make", component: SearchResultsGridLayoutComponent, data: { hideFooter: true, doNotUpdateSeo: true } },
];

@NgModule({
  declarations: [SearchResultsGridLayoutComponent, NoSearchResultsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SearchResultsSharedModule,
    LayoutModule,
    RubblFormsModule,
    CartModule,
    NgxSkeletonLoaderModule,
    MatPaginatorModule,
    MarketingModule,
    NgbPaginationModule,
    SearchResultsModule,
  ],
})
export class SearchResultsGridModule {}
